module.exports = __webpack_public_path__ + "img/2.411781d8.jpg";